import {
    NinchatActionType,
    NinchatDeleteTagAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const deleteTag = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDeleteTagAction}`,
    async (arg: NinchatActionParams<NinchatDeleteTagAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDeleteTagAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
